module.exports = __webpack_public_path__ + "images/165_160.jpg";